// extracted by mini-css-extract-plugin
export default {"container":"RtskE","library":"ZS8t7","library-closed":"WI5U6","workspace":"ZrPEz","workspace-only":"euu71","workspace-scrollable":"j5qqO","workspace-content":"eqJ0X"};